import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _ from 'lodash';
import includes from 'lodash/includes';
import ProjectPage from './../../components/ProjectView';
import {
  getProject,
  updateFreelancerBid,
  getProjectFreelancers,
  changePageState,
  acceptBid,
  getManagers,
  getFreelancers,
  saveProjectFormInfo, resendConfirmationEmail,
} from '../../store/actions/ProjectView';
import BidSubmissionForm from '../../components/ProjectView/BidSubmission';
import {
  mapFreelancerSkillsToDescription,
  mapFreelancerSkillsToDescriptionWithCategory,
  routesAction,
} from '../../shared/helpers';
import SelectFreelancer from '../../components/ProjectView/SelectFreelancer/SelectFreelancer';
import {
  saveProgress,
  selectProject,
  selectProjectRequest,
} from '../../store/actions/Dashboard';
import ProjectViewHeader from '../../components/ProjectView/ProjectViewHeader/ProjectViewHeader';
import { FreelancerProfilePopup } from '../../components/Popup/FreelancerProfilePopup';
import { closeDialog, openDialog } from '../../store/actions/Dialog';
import { ProjectViewProvider } from './ProjectView.context';
import {
  setCurrentOnboardingStep,
  uploadFile,
  uploadingAttachmentRequest,
  uploadingProjectPictureRequest,
} from '../../store/actions/Onboarding';
import { initialState } from '../../store/reducers/Onboarding';
import ProjectViewManagerHeader from '../../components/ProjectView/ProjectViewManagerHeader/ProjectViewManagerHeader';
import { addFlashMessage } from '../../store/actions/Flash';

const maps = {
  formatLabel: m => `${m.label} ${m.boldLabel}`,
  label: m => m.label,
};

class ProjectView extends Component {
  constructor(props) {
    super(props);
    this.getNotRequired = this.getNotRequired.bind(this);
    this.getaudRequired = this.getaudRequired.bind(this)
    this.video_layoutRequired = this.video_layoutRequired.bind(this)
    this.handleSubmitBid = this.handleSubmitBid.bind(this);
    this.selectFreelancer = this.selectFreelancer.bind(this);
    this.acceptFreelancerBid = this.acceptFreelancerBid.bind(this);
    this.handleSubmitDraft = this.handleSubmitDraft.bind(this);
    this.handleEditProject = this.handleEditProject.bind(this);
    this.handleUpdateProjectStatus = this.handleUpdateProjectStatus.bind(this);
    this.handleChangeManager = this.handleChangeManager.bind(this);
    this.loadUsersInfo = this.loadUsersInfo.bind(this);
    this.handleChangeFreelancer = this.handleChangeFreelancer.bind(this);
    this.handleAddProjectFileResources = this.handleAddProjectFileResources.bind(
      this,
    );
    this.handleEditAction = this.handleEditAction.bind(this);
    this.updateFormInfo = this.updateFormInfo.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.loadProjectInfo();
  }

  handleSubmitDraft(drafts, setSubmitting) {
    const {
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
      dispatchGetProject,
    } = this.props;

    dispatchSaveProgress({ drafts_attributes: drafts }, projectId)
      .then(() => {
        this.turnPastProject();
      })
      .then(() => dispatchGetProject(projectId))
      .then(() => setSubmitting(false));
  }

  handleUpdateProjectStatus(status) {
    const {
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
      dispatchGetProject,
      dispatchMessage,
      user: { id },
      history: { push },
    } = this.props;

    dispatchSaveProgress({ status, manager_id: id }, projectId).then(() => {
      if (status === 'discarded') {
        push(routesAction.default());
        dispatchMessage('Project discarded with success!', 'success');
      } else {
        dispatchGetProject(projectId);
      }
    });
  }

  handleChangeManager(e, { value: managerId }) {
    const {
      user,
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
      dispatchGetProject,
      dispatchMessage,
      project,
    } = this.props;

    if (user.type !== 'Master' && project.manager.id === managerId) return;

    dispatchSaveProgress({ manager_id: managerId }, projectId).then(action => {
      if (_get(action, 'type') === 'SAVE_PROJECT_SUCCESS') {
        dispatchGetProject(projectId).then(() => {
          dispatchMessage('Manager changed with success!', 'success');
        });
      }
    });
  }

  handleChangeFreelancer(e, { value: freelancerId }) {
    const {
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
      dispatchGetProject,
      dispatchMessage,
    } = this.props;

    dispatchSaveProgress({ freelancer_id: freelancerId }, projectId).then(
      action => {
        if (_get(action, 'type') === 'SAVE_PROJECT_SUCCESS') {
          dispatchGetProject(projectId).then(() => {
            dispatchMessage('Freelancer changed with success!', 'success');
          });
        }
      },
    );
  }

  handleEditAction(action) {
    const newPageState = {
      ...this.props.pageState,
      [action]: !this.props.pageState[action],
    };
    if (action === 'editReferences') newPageState.editAdditionalInfo = false;
    if (action === 'editAdditionalInfo') {
      this.updateFormInfo({
        target: {
          name: 'references',
          value: _.cloneDeep(this.props.project.references),
        },
      });
      newPageState.editReferences = false;
    }
    this.props.dispatchChangePageState(newPageState);
  }

  updateFormInfo(event) {
    const value = { [event.target.name]: event.target.value };
    this.props.dispatchUpdateFormInfo(value);
  }

  submitForm({ projectData, id }) {
    this.props.dispatchSaveProgress(projectData, id);
  }

  turnPastProject() {
    const {
      match: {
        params: { project_id: projectId },
      },
      history,
      dispatchSaveProgress,
      project: { drafts },
    } = this.props;

    const submittedDrafts = drafts.filter(
      draft => draft.status === 'submitted',
    );

    if (submittedDrafts.length === 4) {
      dispatchSaveProgress({ status: 'past' }, projectId, false).then(() =>
        history.push(routesAction.default()),
      );
    }
  }

  loadProjectInfo() {
    const {
      user,
      match: {
        params: { project_id: projectId },
      },
      dispatchGetProject,
      dispatchGetProjectFreelancers,
    } = this.props;

    dispatchGetProject(projectId).then(() => {
      dispatchGetProjectFreelancers(projectId);
    });

    if (includes(['Manager', 'Master'], user.type)) {
      this.loadUsersInfo();
    }
  }

  loadUsersInfo() {
    const { dispatchGetManagers, dispatchGetFreelancers } = this.props;
    dispatchGetManagers();
    dispatchGetFreelancers();
  }

  getNotRequired() {
    const {
      currentOnboardingSteps: {
        basic_information: { onboardingSteps },
      },
    } = this.props;

    const projectRequirementsKey = 'project_requirements';

    const projectRequirements = this.getResponses(projectRequirementsKey)(i =>
      _get(i, 'question_response', ''),
    );
    return onboardingSteps
      .find(question => question.key === projectRequirementsKey)
      .cards.filter(card => !projectRequirements.includes(card.value))
      .map(maps.label);
  }


  getaudRequired() {
    const {
      currentOnboardingSteps: {
        basic_information: { onboardingSteps },
      },
    } = this.props;

    const projectRequirementsKey = 'audience';

    const projectRequirements = this.getResponses(projectRequirementsKey)(i =>
      _get(i, 'question_response', ''),
    );
    return onboardingSteps
      .find(question => question.key === projectRequirementsKey)
      .cards.filter(card => !projectRequirements.includes(card.value))
      .map(maps.label);
  }


  video_layoutRequired() {
    const {
      currentOnboardingSteps: {
        basic_information: { onboardingSteps },
      },
    } = this.props;

    const projectRequirementsKey = 'video_layout';

    const projectRequirements = this.getResponses(projectRequirementsKey)(i =>
      _get(i, 'question_response', ''),
    );
    return onboardingSteps
      .find(question => question.key === projectRequirementsKey)
      .cards.filter(card => !projectRequirements.includes(card.value))
      .map(maps.label);
  }


  getFormats(response) {
    return response.card.map(maps.formatLabel);
  }

  getLabels(response) {
    return _get(response, 'card', []).map(
      card => (card.value === 'other' ? response.input_value : card.label),
    );
  }

  getResponses = key => get => {
    const { project } = this.props;
    const response = project.project_onboarding_infos.find(
      info => info.question.key === key,
    );
    return get(response);
  };

  handleSubmitBid({ bid }, setSubmitting) {
    setSubmitting(true);
    const {
      project: { id: projectId, bids },
      dispatchUpdateFreelancerBid,
      history: { push },
    } = this.props;

    const [freelancerBid] = bids;

    dispatchUpdateFreelancerBid({
      freelancer_price: bid,
      projectId,
      bidId: freelancerBid.id,
    }).then(() => push(routesAction.default()));
  }

  getHeader() {
    const {
      user: { type },
    } = this.props;

    if (type === 'Client') {
      return 'header';
    }

    if (includes(['Manager', 'Master'], type)) {
      return 'manager_header';
    }

    return null;
  }

  renderHeader(headerKey, props) {
    const { project } = this.props;

    const headers = {
      bid: () => (
        <BidSubmissionForm
          project={project}
          handleSubmitBid={this.handleSubmitBid}
        />
      ),
      header: () => <ProjectViewHeader project={project} />,
      manager_header: () => <ProjectViewManagerHeader project={project} />,
      select_freelancer: localProps => (
        <SelectFreelancer
          project={project}
          {...localProps}
          selectFreelancer={this.selectFreelancer}
        />
      ),
    };

    return headers[headerKey](props);
  }

  acceptFreelancerBid(bidId) {
    const {
      project: { id: projectId },
      dispatchAcceptBid,
      history: { push },
    } = this.props;

    dispatchAcceptBid({
      projectId,
      bid_id: bidId,
    }).then(() => push(routesAction.payment(projectId)));
  }

  selectFreelancer(bidId) {
    const {
      project: { id: projectId, bids },
      dispatchCloseDialog,
    } = this.props;

    const bid = bids.find(bd => bd.id === bidId);

    const freelancerProfilePopup = {
      id: 'freelancer-profile-popup',
      body: (
        <FreelancerProfilePopup
          projectId={Number(projectId)}
          freelancer={{
            ...bid.freelancer,
            formatted_skills: mapFreelancerSkillsToDescription(
              bid.freelancer.skills,
            ),
            ...mapFreelancerSkillsToDescriptionWithCategory(
              bid.freelancer.skills,
            ),
            accepting: true,
          }}
          bid={bid}
          acceptFreelancerBid={this.acceptFreelancerBid}
          dispatchCloseDialog={dispatchCloseDialog}
        />
      ),
    };

    this.props.dispatchOpenDialog(freelancerProfilePopup);
  }

  handleEditProject(selectedProject) {
    const {
      dispatchGoToQuestionStep,
      dispatchSelectProject,
      history: { push },
    } = this.props;
    dispatchSelectProject(selectedProject.id, selectedProject);
    dispatchGoToQuestionStep(initialState.currentStep);
    push(routesAction.onboarding(selectedProject.id));
  }

  handleAddProjectFileResources(dropboxUrls) {
    const {
      match: {
        params: { project_id: projectId },
      },
      dispatchSaveProgress,
    } = this.props;

    const project = {
      dropbox_urls: dropboxUrls,
      answered_questions: [{ key: 'files', question_response: ['dropbox'] }],
    };

    dispatchSaveProgress(project, projectId).then(() => this.loadProjectInfo());
  }

  render() {
    const {
      user: { type },
      freelancers,
      isLoading,
      managers,
      project,
      user,
      pageState,
      currentOnboardingSteps,
    } = this.props;

    const headerKey = this.getHeader();

    return !isEmpty(project.id) ? (
      <ProjectViewProvider
        value={{
          handleUpdateProjectStatus: this.handleUpdateProjectStatus,
          handleChangeFreelancer: this.handleChangeFreelancer,
          handleChangeManager: this.handleChangeManager,
          handleEditProject: this.handleEditProject,
          freelancers,
          isLoading,
          managers,
          user,
          pageState,
        }}
      >
        <ProjectPage
          dispatchResendConfirmation={this.props.dispatchResendConfirmation}
          dispatchProjectFileUpload={this.props.dispatchProjectFileUpload}
          project={project}
          emailConfirmed={user.confirmed}
          email={user.email}
          currentOnboardingSteps={currentOnboardingSteps}
          getFormats={this.getFormats}
          getLabels={this.getLabels}
          getResponses={this.getResponses}
          getNotRequired={this.getNotRequired}
          getaudRequired={this.getaudRequired}
          video_layoutRequired={this.video_layoutRequired}
          client={type === 'Client'}
          manager={['Manager', 'Master'].includes(type)}
          handleEditAction={this.handleEditAction}
          pageState={pageState}
          headerKey={headerKey}
          handleSubmitDraft={this.handleSubmitDraft}
          handleAddProjectFileResources={this.handleAddProjectFileResources}
          updateFormInfo={this.updateFormInfo}
          submitForm={this.submitForm}
          formInfo={this.props.formInfo}
          dispatchUpdateFormInfo={this.props.dispatchUpdateFormInfo}
        >
          {headerKey && type !== 'Client' && this.renderHeader(headerKey)}
        </ProjectPage>
      </ProjectViewProvider>
    ) : null;
  }
}

const mapStateToProps = state => {
  const currentOnboardingSteps = state.onboarding;
  const { isSavingProject, isFetching } = currentOnboardingSteps;

  const {
    project,
    managers,
    freelancers,
    pageState,
    formInfo,
  } = state.projectView;
  const { user } = state.authentication;

  return {
    isLoading: isSavingProject || isFetching,
    currentOnboardingSteps,
    freelancers,
    managers,
    project,
    user,
    pageState,
    formInfo,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatchResendConfirmation: email => {
    dispatch(resendConfirmationEmail(email));
  },
  dispatchProjectFileUpload: (
    overviewStep,
    onboardingStep,
    file,
    fileOrigin,
    updateFormInfo,
    formInfo,
  ) => {
    switch (fileOrigin) {
      case 'attachment':
        dispatch(uploadingAttachmentRequest());
        break;
      case 'project_picture':
        dispatch(uploadingProjectPictureRequest());
        break;
      default:
        dispatch(addFlashMessage(['Not recognized file origin'], 'error'));
    }
    dispatch(
      uploadFile(
        overviewStep,
        onboardingStep,
        file,
        fileOrigin,
        updateFormInfo,
        formInfo,
      ),
    );
  },
  dispatchGetProject: id => dispatch(getProject(id)),
  dispatchGetProjectFreelancers: id => dispatch(getProjectFreelancers(id)),
  dispatchUpdateFreelancerBid: params => dispatch(updateFreelancerBid(params)),
  dispatchChangePageState: newPageState =>
    dispatch(changePageState(newPageState)),
  dispatchAcceptBid: params => dispatch(acceptBid(params)),
  dispatchSaveProgress: (saveInfo, projectId) =>
    dispatch(saveProgress(saveInfo, projectId, false)).then(() =>
      dispatch(getProject(projectId)),
    ),
  dispatchOpenDialog: (content, options) => {
    dispatch(openDialog(content, options));
  },
  dispatchCloseDialog: () => {
    dispatch(closeDialog());
  },
  dispatchSelectProject: (projectId, selectedProject) => {
    dispatch(selectProjectRequest());
    dispatch(selectProject(projectId, selectedProject));
  },
  dispatchGoToQuestionStep: onboardingStep => {
    dispatch(setCurrentOnboardingStep(onboardingStep));
  },
  dispatchMessage: (messages, type = 'error') =>
    dispatch(addFlashMessage(messages, type)),
  dispatchGetManagers: () => dispatch(getManagers()),
  dispatchGetFreelancers: () => dispatch(getFreelancers()),
  dispatchUpdateFormInfo: value => dispatch(saveProjectFormInfo(value)),
});

ProjectView.propTypes = {
  dispatchGetProjectFreelancers: PropTypes.func,
  dispatchUpdateFreelancerBid: PropTypes.func,
  dispatchGetFreelancers: PropTypes.func,
  dispatchSaveProgress: PropTypes.func,
  dispatchChangePageState: PropTypes.func,
  dispatchGetManagers: PropTypes.func,
  dispatchGetProject: PropTypes.func,
  dispatchMessage: PropTypes.func,
  dispatchUpdateFormInfo: PropTypes.func,
  managers: PropTypes.array,
  project: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  user: PropTypes.object,
  pageState: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectView);



// WEBPACK FOOTER //
// ./src/containers/ProjectView/ProjectView.js